import { render } from "./ZonePage.vue?vue&type=template&id=ad700958"
import script from "./ZonePage.vue?vue&type=script&lang=js"
export * from "./ZonePage.vue?vue&type=script&lang=js"
script.render = render

export default script